import { getMyPrizes } from "@/services/modules/postalNewCustomer";

export const namespace = "postalNewCustomer";

export const actions = {
  GET_MY_REWARD: "GET_MY_REWARD"
};

export const mutations = {
  SET_MY_REWARD_LIST: "SET_MY_REWARD_LIST"
};

export default {
  namespaced: true,
  state: {
    myRewardList: []
  },
  mutations: {
    [mutations.SET_MY_REWARD_LIST](state, value) {
      state.myRewardList = value;
    }
  },
  actions: {
    [actions.GET_MY_REWARD]({ commit }, params) {
      return new Promise(async (resolve, reject) => {
        const res = await getMyPrizes(params);
        if (res.respcod === "01") {
          commit(mutations.SET_MY_REWARD_LIST, res.data);
          resolve(res);
        } else {
          reject(res);
        }
      });
    }
  }
};
